import { useDesktopView } from 'utils/hooks/useDesktopView'

export const useProfileDesktopView = () =>
  useDesktopView('profil-desktop-view-enabled')
